import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './TableFooter.scss';

class TableFooter extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  };

  render() {
    const { children, className } = this.props;
    const classComponent = classNames('table-footer', className);

    return (
      <div role="rowgroup" className={classComponent}>
        {children}
      </div>
    );
  }
}

export default TableFooter;
